import {create, DIV} from '@acng/frontend-bounty/dom/element.js';
import {MOUSEENTER, off, on} from '@acng/frontend-bounty/dom/event.js';
import {AttributeLink, AttributeSetup, getConfig} from '@acng/frontend-stargazer';
import {getEngine} from './click-popup';
import {close, open} from '@acng/frontend-relativity';
import {popup} from '@acng/frontend-discovery';
import {DiscardingQueue} from '@acng/frontend-bounty/timing/discarding-queue.js';
import {documentElement} from '@acng/frontend-bounty';

/**
 * @group DOM Attribute
 */
const name = 'onmouseenter-popup';

AttributeSetup(name, (name) => {
  const queue = DiscardingQueue();
  AttributeLink(name, (element, value, outer) => () => {
    const onMouseEnter = () => {
      queue(async () => {
        documentElement.click(); /* trigger popups light dismiss */
        const engine = await getEngine(outer, value);
        const controller = popup(element);
        const div = create(DIV);

        open(element, div);
        engine.toElement(div, getConfig(outer));
        controller.add(div, 0).finally(() => {
          engine.disconnect();
          close(element, div);
        });
      });
    };

    on(element, MOUSEENTER, onMouseEnter);

    return () => off(element, MOUSEENTER, onMouseEnter);
  });
});

export {name as ONMOUSEENTER_POPUP};
